import { watch } from 'vue';
import { COMMANDS } from '@/Utils/vice-constants';
import useSessionStore from '@/Stores/useSessionStore';

const sessionStore = useSessionStore();

function useJitsiCommands(jitsiRoom) {
  const kickScreensharingUser = () => {
    Object.keys(sessionStore.screenShares).forEach((key) => {
      sessionStore.screenShares[key].screenshareOngoing = false;
    });
  };

  const muteAllParticipants = (state) => {
    if (!sessionStore.isClinician) return;
    // Send a command to all participants to update their UI accordingly
    jitsiRoom.value.sendCommandOnce(COMMANDS.MUTE_ALL_PARTICIPANTS, {
      value: COMMANDS.MUTE_ALL_PARTICIPANTS,
      attributes: {
        muteAudio: state,
      },
      children: [],
    });
  };

  const muteSingleParticipant = (participantJitsiId) => {
    // Send a command to all participants to update their UI accordingly
    jitsiRoom.value.sendCommandOnce(COMMANDS.MUTE_SINGLE_PARTICIPANT, {
      value: COMMANDS.MUTE_SINGLE_PARTICIPANT,
      attributes: {
        participantJitsiId,
      },
      children: [],
    });
  };

  const muteMedia = (jitsiId, state) => {
    sessionStore.muted = state
      ? [...sessionStore.muted, jitsiId]
      : sessionStore.muted.filter((id) => id !== jitsiId);

    jitsiRoom.value.sendCommandOnce(COMMANDS.MUTE_MEDIA, {
      value: COMMANDS.MUTE_MEDIA,
      attributes: { muted: sessionStore.muted },
      children: [],
    });
  };

  const kickParticipant = (participantJitsiId) => {
    // Send a command to all participants to update their UI accordingly
    jitsiRoom.value.sendCommandOnce(COMMANDS.KICK_PARTICIPANT, {
      value: COMMANDS.KICK_PARTICIPANT,
      attributes: {
        participantJitsiId,
      },
      children: [],
    });
  };

  const toggleRaiseHand = (args) => {
    jitsiRoom.value.sendCommandOnce(COMMANDS.RAISE_HAND, {
      value: COMMANDS.RAISE_HAND,
      attributes: args,
      children: [],
    });
  };

  const pauseCurrentPhase = (isPaused) => {
    // The event is send to jitsi only via clinician
    if (!sessionStore.isClinician) return;

    jitsiRoom.value.sendCommandOnce(COMMANDS.PAUSE_CURRENT_PHASE, {
      value: COMMANDS.PAUSE_CURRENT_PHASE,
      attributes: {
        isPhasePaused: isPaused,
      },
      children: [],
    });
  };

  const goToNextPhase = (
    thisCurrentPhase,
    isVideoConference,
    isConsultationVideo,
    phaseEnded,
    isForcedEnd,
    backToPreviousPhase,
  ) => {
    jitsiRoom.value.sendCommandOnce(COMMANDS.GO_TO_NEXT_PHASE, {
      value: COMMANDS.GO_TO_NEXT_PHASE,
      attributes: {
        currentPhase: thisCurrentPhase,
        isVideoConference,
        isConsultationVideo,
        phaseEnded,
        isForcedEnd,
        backToPreviousPhase,
      },
      children: [],
    });
  };

  const sendViceMessage = (payload) => {
    if (!jitsiRoom.value) return;
    jitsiRoom.value.sendCommandOnce(COMMANDS.SEND_VICE_MESSAGE, {
      value: COMMANDS.SEND_VICE_MESSAGE,
      attributes: payload,
      children: [],
    });
  };

  const sendPutOnHoldCommand = (isOnHold) => {
    jitsiRoom.value.sendCommandOnce(COMMANDS.PUT_ON_HOLD, {
      value: COMMANDS.PUT_ON_HOLD,
      attributes: {
        isOnHold,
        userRoomId: jitsiRoom.value.myUserId(),
      },
      children: [],
    });
  };

  watch(
    () => sessionStore.isPhasePaused,
    (isPaused) => {
      if (jitsiRoom.value) {
        pauseCurrentPhase(isPaused);
      }
    },
  );

  return {
    toggleRaiseHand,
    goToNextPhase,
    sendViceMessage,
    pauseCurrentPhase,
    muteAllParticipants,
    muteSingleParticipant,
    muteMedia,
    kickParticipant,
    kickScreensharingUser,
    sendPutOnHoldCommand,
  };
}

export default useJitsiCommands;
